export default [
  {
    name: 'GoodsManagement',
    path: 'goodsManagement',
    meta: {
      title: '发布商品--选择类目'
    },
    component: () =>
      import( /* webpackChunkName: "pop-goodsManagement" */ '../views/goodsManagement/choose-category.vue')
	},
	{
    name: 'PerfectInformation',
    path: 'perfectInformation',
    meta: {
      title: '发布商品--完善资料'
    },
    component: () =>
      import( /* webpackChunkName: "pop-goodsManagement" */ '../views/goodsManagement/perfect-information.vue')
	},
	{
    name: 'ManagementList',
    path: 'managementList',
    meta: {
      title: '商品管理列表'
    },
    component: () =>
      import( /* webpackChunkName: "pop-managementList" */ '../views/goodsManagement/management-list.vue')
	},
	/** 商品资质管理 */
    {
    name: 'GoodsQualificationList',
    path: 'goodsQualificationList',
    meta: {
      title: '商品资质管理列表'
    },
    component: () =>
      import( /* webpackChunkName: "goods-qalification-list" */ '../views/goodsManagement/goods_qualification.vue')
	},
	{
    name: 'GoodsQalificationDetail',
    path: 'goodsQalificationDetail',
    meta: {
      title: '商品资质详情'
    },
    component: () =>
      import( /* webpackChunkName: "goods-qalification-list" */ '../views/goodsManagement/goods_qualification_detail.vue')
	},
	// {
  //   name: 'TourismReport',
  //   path: 'tourismReport',
  //   meta: {
	// 		title: '旅游提报'
  //   },
  //   component: () =>
	// 		import( /* webpackChunkName: "tourism_report" */ '../views/goodsManagement/tourism_report.vue')
	// },
	{
    name: 'DraftBox',
    path: 'draftBox',
    meta: {
      title: '草稿箱'
    },
    component: () =>
      import( /* webpackChunkName: "pop-draftBox" */ '../views/goodsManagement/draft-box.vue')
	},
	{
    name: 'GoodsEdit',
    path: 'goodsEdit',
    meta: {
      title: '商品详情'
    },
    component: () =>
      import( /* webpackChunkName: "pop-goodsEdit" */ '../views/goodsManagement/goods-edit.vue')
	},
	/** 规则中心 */
  {
    path: 'rulePage',
    name: 'rulePage',
    meta: {
      title: '规则中心'
    },
    component: () => import( /* webpackChunkName: "rule-page" */ '../views/goodsManagement/rule_page.vue')
  },
  /** 新品发布商品纠错模板 */
  {
    name: 'correctionProductTemplate',
    path: 'correctionProductTemplate',
    meta: {
      title: '商品模板信息纠错'
    },
    component: () =>
      import( /* webpackChunkName: "pop-goodsManagement" */ '../views/goodsManagement/correction_product_template.vue')
  },
  /** 新品发布商品纠错模板 */
  {
    name: 'imgSpecs',
    path: 'imgSpecs',
    meta: {
      title: '图片规范'
    },
    component: () =>
      import( /* webpackChunkName: "pop-imgSpecs" */ '../views/goodsManagement/imgSpecs.vue')
  },
   /** 新品发布商品纠错模板 */
  {
    name: 'commidityRecord',
    path: 'commidityRecord',
    meta: {
      title: '商品备案所需信息提报'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodityRecord" */ '../views/goodsManagement/commodityFiling/commodityRecord.vue')
  },
  {
    name: 'batchReleaseGoods',
    path: 'batchReleaseGoods',
    meta: {
      title: '批量发布商品'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodityRecord" */ '../views/goodsManagement/batchReleaseGoods/batchReleaseGoods.vue')
  },
  {
    name: 'importTaskList',
    path: 'importTaskList',
    meta: {
      title: '导入任务列表'
    },
    component: () =>
      import( /* webpackChunkName: "pop-commodityRecord" */ '../views/goodsManagement/batchReleaseGoods/importTaskList.vue')
  },
  {
    name: 'eliminateBox',
    path: 'eliminateBox',
    meta: {
      title: '淘汰库'
    },
    component: () =>
      import( /* webpackChunkName: "pop-draftBox" */ '../views/goodsManagement/eliminateBox.vue')
	}
    ,
    {
        name: 'productCustomsRecord',
        path: 'productCustomsRecord',
        meta: {
            title: '商品备案同步'
        },
        component: () =>
            import( /* webpackChunkName: "pop-draftBox" */ '../views/goodsManagement/productCustomsRecord/productCustomsRecord.vue')
    }
]